<div class="content">
    <div class="about">
        <img class="perfil-img" [defaultImage]="defaultImg" [lazyLoad]="profile.img">
        <div class="desc"> <figure><img src="assets/svg/quote.svg"></figure> <p [innerHTML]="profile.description"> /p></div>
        <a routerLink="/contact">Contactame</a>
    </div>
</div>